export class OrderStatuses {
  static statuses = {
    new: 1,
    finalized: 7,
  };
}
